module.exports = __webpack_public_path__ + "media/images/icon-indent-af0dab804851324cb79fe03ec90b6709.svg";